import {getToken, onMessage} from "firebase/messaging";
import {messaging} from "../firebase";

const VAPID_KEY =
    "BDOGBKjjpbWoidI3ZmclYotJ1M0GYGn7Bj4P80ntwJMLCR1ILDdW8bh8Y-33FY5rrKMf4pBD1QbpOGd5oVB2Yk4";

export {getToken, messaging, onMessage, VAPID_KEY};
